import LocationAdapter from './location_adapter';
import URLUtils from '@javascripts/utils/url_utils';

export default class PubmaticAdapter {
  static appendOpenWrapTargeting(tag, pubmaticUrl, callbackFn){
    const xhr = new XMLHttpRequest();
    xhr.timeout = 1000;
    xhr.withCredentials = true;
    xhr.open("GET", pubmaticUrl);
    xhr.onload = function() {
      let appendedTag = tag;
      if(xhr.status == 200) {
        appendedTag = PubmaticAdapter.openWrapRequestSuccess(tag, xhr.response);
      }

      callbackFn(appendedTag);
    }.bind(this);

    xhr.ontimeout = function() {
      callbackFn(tag);
    }

    xhr.onerror = function() {
      callbackFn(tag);
    }

    xhr.send();
  }

  static openWrapRequestSuccess(tag, response) {
    let jsonResponse;
    try {
      jsonResponse = JSON.parse(response);
    } catch(e) {
      return tag;
    }

    if (!jsonResponse.targeting) return tag;
    
    const pubmaticCustomParams = new URLSearchParams(jsonResponse.targeting).toString();
    if (pubmaticCustomParams == "") return tag;

    const tagCustomParams = URLUtils.getQueryParam(tag, "cust_params");
    if (tagCustomParams == "") {
      return URLUtils.addQueryParam(tag, "cust_params", encodeURIComponent(pubmaticCustomParams));
    }
    
    const customParams = tagCustomParams + "&" + pubmaticCustomParams;
    return URLUtils.addQueryParam(tag, "cust_params", encodeURIComponent(customParams));
  }
}
